<template>
  <div class="risk-box">
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <div class="risk-tips">
        注：风控规则由向日葵平台保留最终解释权，所有风控内容最终以向日葵平台设置的可调范围为准。
      </div>
      <el-form-item label="执行者年龄区间：">
        <el-input disabled :value="ruleForm.ageStart" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input disabled :value="ruleForm.ageEnd" placeholder="">
          <span disabled slot="suffix">岁</span>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { makeSure } from '@/Mixin/makeSure';
import { riskControl } from '@/api/ajax';
export default {
  mixins: [makeSure],
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: function() {
        return {};
      }
    },

    listobj: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      ruleForm: {}
    };
  },
  methods: {
    fommatNumber(key) {
      this.ruleForm[key] = this.ruleForm[key].replace(/[^0-9]/g, '');
    }
  },
  async created() {
    const {
      data: { data }
    } = await riskControl.elseComponent.detail({
      projectId: this.$route.query.id
    });
    this.ruleForm = JSON.parse(data.paramJson);
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
